import React from 'react'
import Container from 'components/Container'
import Wrapper from 'components/Wrapper'
import Editorial from 'components/Editorial'
import Header from 'apps/booking/components/Header'

export default function PrivacyPage() {
  return (
    <>
      <Header
        seoTitle="Personvernerklæring for timesbestilling"
        description="For Remin Timebestilling, 8. oktober 2020"
      />
      <main>
        <Container size="tight">
          <h1>Personvernerklæring</h1>
          <p>For Remin Timebestilling, 8. oktober 2020</p>
        </Container>
        <Wrapper size="tight">
          <Editorial>
            <h2>Generell informasjon</h2>
            <p>
              For å kunne gjennomføre effektiv smittetesting og vaksinering har kommunen lagt til
              rette for timebestilling ved hjelp av en digital løsning.
            </p>
            <p>
              For å sikre god og effektiv timebestilling, - gjennomføring og oppfølging samler vi
              inn disse kategorier av personopplysninger om deg:
            </p>
            <ul>
              <li>Navn, adresse og telefonnummer</li>
              <li>Fødselsnummer (11-siffer)</li>
              <li>Kjønn</li>
              <li>Bakgrunn for testing</li>
              <li>Informasjon om underliggende lidelser</li>
              <li>Informasjon om allergi i forbindelse med vaksiner</li>
            </ul>
            <p>
              Opplysningene du registrerer vil bli lagret i timebestillingssverktøyet Remin
              Timebestilling, og opplysninger vil bli slettet når lagring ikke lenger er påkrevd.
            </p>
            <h2>Dine rettigheter</h2>
            <h3>Innsyn</h3>
            <p>
              Du har rett til innsyn og kan henvende deg til kommunen og be om å få innsyn i
              registrerte helse- og personopplysninger. Foreldre/foresatte har rett til å vite
              hvilke opplysninger som er registrert om egne barn frem til de er 16 år, men dersom
              barnet er mellom 12 og 16 år skal det få uttale seg før innsyn eventuelt kan gis.
            </p>
            <h3>Retting</h3>
            <p>
              Dersom du oppdager feilaktige personopplysninger om deg selv kan du kreve at vi
              korrigerer informasjonen. Kommunen har også en plikt på eget initiativ rette
              mangelfulle eller feilaktige opplysninger.
            </p>
            <h3>Begrensning eller sletting</h3>
            <p>
              Dersom du mener kommunen registrerer informasjon om deg som ikke er nødvendig, kan du
              be om at denne informasjonen blir begrenset eller slettet. Dette gjelder ikke dersom
              opplysningene skal oppbevares i henhold til annen lovgivning, for eksempel
              journalloven eller arkivloven.
            </p>
            <h3>Informasjon</h3>
            <p>
              Kommunen har plikt til å behandle personopplysninger på en åpen måte. Dette innebærer
              at vi må gi kort og forståelig informasjon om hvordan de behandler
              personopplysningene. Det stilles også krav til hvordan vi kommuniserer med deg som
              enkeltperson.
            </p>
            <h3>Svarfrist og kostnader</h3>
            <p>
              Vi vil svare på alle henvendelser innen 30 dager, og vi vil be deg om å bekrefte
              identiteten din eller å oppgi ytterligere informasjon før vi lar deg ta i bruk dine
              rettigheter overfor oss. Dette gjør vi for å være sikre på at du er den du er, og at
              ingen andre gir seg ut for å være deg.
            </p>
            <p>
              Når du ber om innsyn, retting, sletting eller tar i bruk andre rettigheter etter
              personvernreglene, er dette gratis, med mindre anmodningene dine er åpenbart grunnløse
              eller overdrevne.
            </p>
            <h3>Klage til Datatilsynet</h3>
            <p>
              Hvis du mener vår behandling av personopplysninger ikke stemmer med det vi har
              beskrevet i personvernerklæringen eller at vi på andre måter bryter
              personvernlovgivningen, så kan du klage til Datatilsynet. Du finner utdypende
              informasjon om dine rettigheter og hvordan du kontakter Datatilsynet på{' '}
              <a href="https://www.datatilsynet.no/rettigheter-og-plikter/den-registrertes-rettigheter/">
                Datatilsynets nettsider
              </a>
              .
            </p>
            <h2>Kontaktdetaljer</h2>
            <p>
              Leder for Helse- og omsorg er øverste ansvarlig for behandling av dine
              personopplysninger i kommunen. Dersom du har spørsmål kan du ringe oss eller sende en
              forespørsel til postmottak eller personvernombud i kommunen.
            </p>
          </Editorial>
        </Wrapper>
      </main>
    </>
  )
}
